import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-piggy-bank-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_19 = { class: "setting-data" }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_22 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "table" }
const _hoisted_25 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_26 = { class: "d-block my-3" }
const _hoisted_27 = { class: "d-none d-md-block" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_30 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_31 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_32 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { colspan: "6" }
const _hoisted_35 = { class: "text-center py-2" }
const _hoisted_36 = { class: "d-none d-md-block" }
const _hoisted_37 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_38 = { style: {"padding":"5px 0"} }
const _hoisted_39 = { class: "bold" }
const _hoisted_40 = { style: {"padding":"5px 0"} }
const _hoisted_41 = { class: "bold" }
const _hoisted_42 = { style: {"padding":"5px 0"} }
const _hoisted_43 = { class: "bold" }
const _hoisted_44 = { style: {"padding":"5px 0"} }
const _hoisted_45 = { class: "bold" }
const _hoisted_46 = {
  style: {"padding":"5px 0"},
  class: "d-flex"
}
const _hoisted_47 = { class: "bold" }
const _hoisted_48 = { class: "flex-fill" }
const _hoisted_49 = { style: {"padding":"5px 0"} }
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_52 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_53 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_54 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_55 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_56 = { class: "bg-very-light" }
const _hoisted_57 = { class: "d-none d-md-block" }
const _hoisted_58 = { class: "d-block d-md-none" }
const _hoisted_59 = { style: {"font-size":"1.0rem"} }
const _hoisted_60 = { style: {"padding":"5px 0"} }
const _hoisted_61 = { class: "bold" }
const _hoisted_62 = { style: {"padding":"5px 0"} }
const _hoisted_63 = { class: "bold" }
const _hoisted_64 = { style: {"padding":"5px 0"} }
const _hoisted_65 = { class: "bold" }
const _hoisted_66 = { style: {"padding":"5px 0"} }
const _hoisted_67 = { class: "bold" }
const _hoisted_68 = { style: {"padding":"5px 0"} }
const _hoisted_69 = { class: "bold" }
const _hoisted_70 = { class: "d-none t-d-md-table-cell text-end bg-very-light" }
const _hoisted_71 = { class: "d-none t-d-md-table-cell text-end bg-very-light" }
const _hoisted_72 = { class: "d-none t-d-md-table-cell text-end bg-very-light" }
const _hoisted_73 = { class: "d-none t-d-md-table-cell text-end bg-very-light pe-5" }
const _hoisted_74 = { class: "d-none t-d-md-table-cell text-end bg-very-light" }
const _hoisted_75 = { class: "col-md-6 col-sm-12" }
const _hoisted_76 = { class: "area-info" }
const _hoisted_77 = { class: "col-md-6 col-sm-12" }
const _hoisted_78 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_RefunInputData = _resolveComponent("RefunInputData")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_RefundOperPaytModal = _resolveComponent("RefundOperPaytModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.ref_details), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              (!_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_RouterLink, { to: "/app/sales/refund/list" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("  " + _toDisplayString(_ctx.language.refund) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.relatedPurchase.record.RefundNbr), 1),
                        _hoisted_13,
                        _createTextVNode("       " + _toDisplayString(_ctx.language.customer) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.orderWithRefInfo.customerName), 1),
                        _hoisted_14,
                        _createTextVNode("       " + _toDisplayString(_ctx.language.ordered_qty) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.orderedQty)) + " (" + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.orderedAmtValue)) + ")", 1),
                        _hoisted_15,
                        _createTextVNode("       " + _toDisplayString(_ctx.language.deliv_qty) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.refundedQty)) + " (" + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.refundedAmtValue)) + ")", 1),
                        _hoisted_16,
                        _createTextVNode("       " + _toDisplayString(_ctx.language.rem_qty) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.remainingQty)) + " (" + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderWithRefInfo.remainingAmtValue)) + ")", 1),
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.ref_details_msg), 1),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.language.ref_details), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.detailListToSave.length == 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveRecordData()))
                  }, [
                    (_ctx.isSavingRecord)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSavingRecord)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          icon: ['fas', 'save']
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.save), 1)
                  ], 8, _hoisted_23)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_24, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.language.ref_details), 1)
                    ]),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.language.product), 1)
                  ]),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.ordered_qty), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.ref_qty), 1),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.language.rem_qty), 1),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.language.to_refund), 1),
                  _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.language.amt_to_ref), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstSalesRefundDataForPrep.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesDet) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesDet.OperationKey
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getProductName(salesDet)), 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.language.product) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getProductName(salesDet)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.language.ordered_qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.Quantity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.language.ref_qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.QuantityRefunded)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.language.rem_qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.RemainingQuantity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.language.to_refund) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", _hoisted_48, [
                            _createVNode(_component_RefunInputData, {
                              refundDataRecord: salesDet,
                              onOnUpdate: _ctx.onRefundUpdate
                            }, null, 8, ["refundDataRecord", "onOnUpdate"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.language.rem_qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.RefundNowTotalAmt)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.Quantity)), 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.QuantityRefunded)), 1),
                    _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.RemainingQuantity)), 1),
                    _createElementVNode("td", _hoisted_54, [
                      _createVNode(_component_RefunInputData, {
                        refundDataRecord: salesDet,
                        onOnUpdate: _ctx.onRefundUpdate
                      }, null, 8, ["refundDataRecord", "onOnUpdate"])
                    ]),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.RefundNowTotalAmt)), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_56, [
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.language.totals), 1),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("h3", _hoisted_59, _toDisplayString(_ctx.language.totals), 1),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.language.ordered_qty) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.Quantity)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.language.ref_qty) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.QuantityRefunded)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.language.ref_qty) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RemainingQuantity)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.language.to_refund) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RefundNowQty)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.language.total) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RefundNowTotalAmt)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.Quantity)), 1),
                  _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.QuantityRefunded)), 1),
                  _createElementVNode("th", _hoisted_72, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RemainingQuantity)), 1),
                  _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RefundNowQty)), 1),
                  _createElementVNode("th", _hoisted_74, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.totalSalesRef.RefundNowTotalAmt)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstSalesRefundDataForPrep.length==0}])
            }, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstSalesRefundDataForPrep.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("nav", _hoisted_78, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_RefundOperPaytModal, {
        visible: _ctx.isSalesPaytVis,
        initialValues: _ctx.salesPaytInitVals,
        recordStatus: _ctx.salesPaytRecStatus,
        remainingAmt: _ctx.salesRemAmt,
        onCloseForm: _ctx.onClosePaytModal,
        populateData: false
      }, null, 8, ["visible", "initialValues", "recordStatus", "remainingAmt", "onCloseForm"])
    ]))
  ], 64))
}